import { useState } from "react";
import { CaretDown, CaretRight } from "@phosphor-icons/react";
import { Money, q } from "./reprogUtil";

function LinhaItem({ it }) {
  const [open, setOpen] = useState(false);
  const temProblema = it.excedente_fisico > 0;
  return (
    <>
      <tr data-testid={`conc-item-${it.codigo}`} style={{ background: temProblema ? "#FEF2F2" : undefined }}>
        <td><button type="button" className="btn btn-ghost btn-sm" style={{ padding: "0 4px" }} onClick={() => setOpen(!open)} data-testid={`conc-toggle-${it.codigo}`}>{open ? <CaretDown size={12} /> : <CaretRight size={12} />}</button> <span className="font-mono">{it.codigo}</span></td>
        <td>{it.descricao}<div style={{ fontSize: "0.65rem", color: "#71717A" }}>{it.faixas.length} faixa(s) de preço</div></td>
        <td>{it.unidade}</td>
        <td className="font-mono" style={{ textAlign: "right" }}>{q(it.qtd_coberta)}</td>
        <td className="font-mono" style={{ textAlign: "right" }}>{q(it.executado_fisico)}</td>
        <td className="font-mono" style={{ textAlign: "right" }}>{q(it.faturado)}</td>
        <td className="font-mono" style={{ textAlign: "right", color: it.liberado_proxima_medicao > 0 ? "#059669" : undefined }}>{q(it.liberado_proxima_medicao)}</td>
        <td className="font-mono font-semibold" style={{ textAlign: "right", color: temProblema ? "#DC2626" : undefined }} data-testid={`conc-excedente-${it.codigo}`}>{q(it.excedente_fisico)}</td>
        <td style={{ textAlign: "right" }}><Money v={it.valor_excedente_estimado} neg testid={`conc-pendente-${it.codigo}`} /></td>
        <td className="font-mono" style={{ textAlign: "right" }}>{q(it.saldo_nao_executado)}</td>
        <td style={{ textAlign: "right" }}><Money v={it.valor_disponivel_reprogramacao} testid={`conc-disponivel-${it.codigo}`} /></td>
      </tr>
      {open && (
        <tr><td colSpan={11} style={{ background: "#FAFAF9", padding: "6px 12px 10px 36px" }}>
          <table className="pcp-table" style={{ fontSize: "0.75rem" }} data-testid={`conc-faixas-${it.codigo}`}>
            <thead><tr><th>Faixa de preço</th><th style={{ textAlign: "right" }}>Qtd coberta</th><th style={{ textAlign: "right" }}>Preço</th><th style={{ textAlign: "right" }}>Executado (FIFO)</th><th style={{ textAlign: "right" }}>Não executado</th><th style={{ textAlign: "right" }}>Comprometido</th><th style={{ textAlign: "right" }}>Disponível p/ reprogramar</th></tr></thead>
            <tbody>
              {it.faixas.map((f) => (
                <tr key={f.faixa_id}><td>{f.origem}{f.reducoes?.length > 0 && <span style={{ color: "#B45309" }}> · reduzida {q(f.reducoes.reduce((s, r) => s + r.qtd, 0))} (reprog. {f.reducoes.map((r) => r.reprogramacao).join(", ")})</span>}</td>
                  <td className="font-mono" style={{ textAlign: "right" }}>{q(f.qtd)}</td><td style={{ textAlign: "right" }}><Money v={f.preco} /></td>
                  <td className="font-mono" style={{ textAlign: "right" }}>{q(f.executado)}</td><td className="font-mono" style={{ textAlign: "right" }}>{q(f.saldo_nao_executado)}</td>
                  <td className="font-mono" style={{ textAlign: "right" }}>{q(f.comprometido)}</td><td className="font-mono font-semibold" style={{ textAlign: "right" }}>{q(f.disponivel_reprogramacao)} <span style={{ color: "#71717A", fontWeight: 400 }}>({<Money v={f.valor_disponivel} />})</span></td></tr>
              ))}
            </tbody>
          </table>
          {it.por_os.length > 0 && <div style={{ fontSize: "0.7rem", color: "#71717A", marginTop: 6 }}>Execução física por OS: {it.por_os.map((p) => `${p.numero} (${q(p.qtd)} ${it.unidade})`).join(" · ")}</div>}
        </td></tr>
      )}
    </>
  );
}

export function ConciliacaoTabela({ conc }) {
  return (
    <div style={{ overflowX: "auto" }} data-testid="conciliacao-tabela">
      <table className="pcp-table">
        <thead><tr>
          <th>Item</th><th>Descrição</th><th>Un</th>
          <th style={{ textAlign: "right" }} title="Contrato + aditivos + reprogramações aplicadas">Coberto</th>
          <th style={{ textAlign: "right" }} title="Soma dos apontamentos (OS não canceladas)">Executado físico</th>
          <th style={{ textAlign: "right" }} title="Quantidade faturada em medições fechadas">Faturado</th>
          <th style={{ textAlign: "right" }} title="Coberto e executado, ainda não medido — entra na próxima medição">Liberado p/ medição</th>
          <th style={{ textAlign: "right" }} title="Executado acima da cobertura">Excedente</th>
          <th style={{ textAlign: "right" }} title="Excedente × preço aplicável (última faixa)">Pendente de cobertura</th>
          <th style={{ textAlign: "right" }} title="Coberto e não executado">Não executado</th>
          <th style={{ textAlign: "right" }} title="Não executado menos o comprometido em propostas ativas">Disponível p/ reprogramar</th>
        </tr></thead>
        <tbody>{conc.itens.map((it) => <LinhaItem key={it.id} it={it} />)}</tbody>
      </table>
    </div>
  );
}
